

let swiperContainers = document.querySelectorAll('.bounce-prompt');

for (let i = 0; i < swiperContainers.length; i++) {
  swiperContainers[i].addEventListener('click', stopBounce);
  swiperContainers[i].addEventListener('touchstart', stopBounce);
}

function stopBounce(event) {
  let container = event.currentTarget;
  container.style.animation = 'none';
}

// Intersection Observer

// Options docs: https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API#Intersection_observer_options
const options = {
    root: null, // use the document's viewport as the container
    rootMargin: '0px', // % or px - offsets added to each side of the intersection 
    threshold: 0.5 // percentage of the target element which is visible
  }
  
  // Callback docs: https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API#Targeting_an_element_to_be_observed
  let callback = (entries) => { 
    entries.forEach(entry => {
      
      // If entry (swiper) is visible - according with the params set in `options`
      // then adds `bounce-prompt` class to swiper
      // otherwise removes `isVisible` class
      
      if(entry.isIntersecting) {
        entry.target.classList.add('bounce-prompt');
      } else {
        entry.target.classList.remove('bounce-prompt');   
      }
  
    });
  }
  
  // Create the intersection observer instance by calling its constructor and passing it a
  // callback function to be run whenever a threshold is crossed in one direction or the other:
  let observer = new IntersectionObserver(callback, options);
  
  // Get all the `.swiper` from DOM and attach the observer to these
document.querySelectorAll('.swiper')
.forEach(swiper => { observer.observe(swiper) });